import SectionBox from "../layout/SectionBox";
import { useEffect, useMemo, useState } from "react";
import { useEventsStore } from "../../store/useEventsStore";
import { ArrowUpRight } from "lucide-react";
import Button from "../atoms/Button";
import { Link, useLocation } from "react-router-dom";
import PageLoader from "../../components/atoms/PageLoader";

export default function EventHome() {
  const [loading, setLoading] = useState(true);
  const { items, fetchEvents } = useEventsStore();
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  useEffect(() => {
    fetchEvents(lang, 1).finally(() => setLoading(false));
  }, [lang, fetchEvents]);

  // =====================
  // MAIN IMAGE (DUMMY)
  // =====================
  const mainImage =
    "https://dummyimage.com/372x392/000/fff";

  // =====================
  // NORMALIZE EVENTS
  // =====================
  const events = useMemo(() => {
    const mapped = items.slice(0, 5).map((item) => ({
      id: item.id,
      title: item.title,
      description: item.contentHtml.replace(/<[^>]+>/g, "").slice(0, 100),
      image: item.image,
      logo: item.event_image_icon,
      link: `/${lang}/blog/events/${item.slug}`,
      isComingSoon: false,
    }));

    if (mapped.length < 5) {
      const fillers = Array.from(
        { length: 5 - mapped.length },
        (_, i) => ({
          id: `coming-soon-${i}`,
          title: "Coming Soon",
          description: "Stay tuned for our upcoming event",
          logo: "/assets/images/coming-soon.png",
          link: undefined,
          isComingSoon: true,
        })
      );

      return [...mapped, ...fillers];
    }

    return mapped;
  }, [items]);

  const mainEvent = events[0];
  const leftEvents = [events[1], events[3]].filter(Boolean);
  const rightEvents = [events[2], events[4]].filter(Boolean);

  const renderCard = (item: any) => (
    <a href={item.link}
      key={item.id}
      className={`relative bg-[#ffffff30] rounded-2xl p-5 shadow-lg flex flex-col flex-1 justify-end  min-h-[220px] overflow-hidden ${
        item.isComingSoon ? "opacity-70 cursor-not-allowed" : ""
      }`}
    >
      {!item.isComingSoon && item.link && (
        <Button
          href={item.link}
          className="absolute top-3 z-10 right-3 !p-0 !border-0 !bg-transparent hover:scale-110 transition-transform duration-300"
        >
          <ArrowUpRight className="w-5 h-5 text-white opacity-80 hover:opacity-100" />
        </Button>
      )}

      <img
        src={item.logo}
        alt={item.title}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

      <div className="relative z-10">
        <h4 className="font-semibold text-white text-lg mb-1">
          {item.title}
        </h4>
        {/* <p className="text-font-alt text-sm leading-relaxed">
          {item.description}
        </p> */}
      </div>
    </a>
  );

  const renderMainCard = (item: any) => {
  if (!item) return null;

  return (
    <Link
      to={item.link}
      className="relative rounded-2xl overflow-hidden shadow-lg flex flex-col justify-end min-h-[460px] w-full bg-black"
    >
      {/* IMAGE */}
      <img
        src={item.image || mainImage}
        alt={item.title}
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* GRADIENT OVERLAY */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

      {/* CONTENT */}
      <div className="relative z-10 p-6">
              {/* <img
        src={item.logo}
        alt={item.title}
        className="h-16 mb-3 w-16 object-contain"
      /> */}
        <h4 className="font-semibold text-white text-xl mb-2">
          {item.title}
        </h4>
        <p className="text-white text-sm leading-relaxed line-clamp-3">
          {item.description}
        </p>
      </div>

      {/* BUTTON */}
      {!item.isComingSoon && item.link && (
        <Button
          href={item.link}
          className="absolute top-4 right-4 !p-0 !border-0 !bg-transparent hover:scale-110 transition-transform duration-300 z-10"
        >
          <ArrowUpRight className="w-6 h-6 text-white opacity-90" />
        </Button>
      )}
    </Link>
  );
};


  return (
    <div className="container-section mx-auto px-6 pt-6">
        {loading && <PageLoader />}
      <SectionBox
        title={
          lang === "id"
            ? "Acara menarik yang membuat kita lebih tinggi"
            : "Cool events that set us higher"
        }
        description={
          lang === "id"
            ? "Jelajahi acara unggulan kami, yang dirancang untuk memberikan kinerja dan Nilai"
            : "Explore our standout event, designed to deliver performance and Value"
        }
        descriptionClassName="!text-white"
        titleAlign="center"
        titleClassName="text-2xl md:text-3xl text-white"
        background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)"
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 w-full px-6 sm:px-2 lg:px-6 xl:px-12">
          {/* KIRI */}
          <div className="grid grid-rows-2 gap-6">
            {leftEvents.map(renderCard)}
          </div>

          {/* TENGAH */}
          <div className="flex items-stretch">
  {renderMainCard(mainEvent)}
</div>


          {/* KANAN */}
          <div className="grid grid-rows-2 gap-6">
            {rightEvents.map(renderCard)}
          </div>
        </div>
      </SectionBox>
    </div>
  );
}
